export default {
  title: "Служба поддержки",
  payments: "Пожалуйста, по всем вопросам касательно выплат пишите на email {finance_email}.",
  spam: 'Важно, проверяйте папку "Спам"!',
  other: "По всем остальным вопросам обращайтесь через форму ниже.",
  faq: "часто задаваемых вопросов",
  faq_notice:
    "Перед отправкой запроса, пожалуйста, изучите наши правила и раздел {faq} (FAQ) — возможно, ответ уже там.",
  response_time:
    "Ответ может занимать от 12 часов до 2 рабочих дней, в зависимости от сложности запроса и загруженности службы поддержки."
};
